import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
import Router from 'vue-router';
import Drip from 'drip';
import Home from '@/pages/home';
import FansRouter from './fans/index';
import TengjingRouter from './tengjing/index';
import MaidanbaRouter from './maidanba/index';
import LiveRouter from './live/index';
import CommentsRouter from './comments/index';
import CmbAppRouter from './cmbApp/index';
import { owlResetPv } from '@/utils/monitor-err/index';
Vue.use(Router);
var routes = [{
  path: '/',
  name: 'Home',
  component: Home
}, {
  path: '/search',
  name: 'search',
  component: function component() {
    return import('@/pages/search');
  },
  children: [{
    path: '/search/:key',
    name: 'searchKey',
    component: function component() {
      return import('@/pages/search');
    }
  }]
}, {
  path: '/venue-list',
  name: 'venue-list',
  component: function component() {
    return import('@/pages/venue-list');
  }
}, {
  path: '/venue-detail/:shopId',
  name: 'VenueDetail',
  component: function component() {
    return import('@/pages/venue-detail');
  }
}, {
  path: '/detail/:performanceId',
  name: 'Detail-new',
  component: function component() {
    return import('@/pages/detail-new-route');
  }
}, {
  path: '/show-detail/:performanceId',
  name: 'ShowDetail',
  component: function component() {
    return import('@/pages/detail/index');
  }
}, {
  path: '/cities',
  name: 'Cities',
  component: function component() {
    return import('@/pages/cities');
  }
}, {
  path: '/list/:categoryId',
  name: 'list',
  component: function component() {
    return import('@/pages/list');
  }
}, {
  path: '/answer-question/:performanceId',
  name: 'answerQuestion',
  component: function component() {
    return import('@/pages/answer-question');
  }
}, {
  path: '/question-new/:performanceId',
  name: 'questionNew',
  component: function component() {
    return import('@/pages/question-new');
  }
}, {
  path: '/fans-buy',
  name: 'fansBuy',
  component: function component() {
    return import('@/pages/fans-buy');
  }
}, {
  path: '/player-detail',
  name: 'playerDetail',
  component: function component() {
    return import('@/pages/player-detail');
  }
}, {
  path: '/collect-list',
  name: 'collectList',
  component: function component() {
    return import('@/pages/collect-list');
  }
}, {
  path: '/group-list',
  name: 'GroupList',
  component: function component() {
    return import('@/pages/group-list');
  }
}, {
  path: '/middle-check',
  name: 'middleCheck',
  component: function component() {
    return import('@/pages/middle-check');
  }
}, {
  path: '/common-info',
  name: 'common-info',
  component: function component() {
    return import('@/pages/common-info');
  }
}, {
  path: '/add-buyer',
  name: 'add-buyer',
  component: function component() {
    return import('@/pages/add-buyer');
  }
}, {
  path: '/add-buyerInfo',
  name: 'add-buyerInfo',
  component: function component() {
    return import('@/pages/add-buyerInfo');
  }
}, {
  path: '/ticket-purchaser-info',
  name: 'ticket-purchaser-info',
  component: function component() {
    return import('@/pages/ticket-purchaser-info');
  }
}, {
  path: '/add-address',
  name: 'add-address',
  component: function component() {
    return import('@/pages/add-address');
  }
}, {
  path: '/search-address',
  name: 'searchAddress',
  component: function component() {
    return import('@/pages/search-address');
  }
}, {
  path: '/buy-check',
  name: 'buyCheck',
  component: function component() {
    return import('@/pages/buy-check');
  }
}, {
  path: '/ticket-good',
  name: 'ticketGood',
  component: function component() {
    return import('@/pages/ticket-good');
  }
}, {
  path: '/ticket-level',
  name: 'ticketLevel',
  // component: () => import( '@/pages/ticket-level' ),
  component: function component() {
    return import('@/pages/ticket-level-router');
  }
}, {
  path: '/pre-ticket',
  name: 'preTicket',
  component: function component() {
    return import('@/pages/pre-ticket');
  }
}, {
  path: '/pre-ticket-v2',
  name: 'preTicket-vw',
  component: function component() {
    return import('@/pages/pre-ticket-v2');
  }
}, {
  path: '/video-page/:id/:vid',
  name: 'video',
  component: function component() {
    return import('@/pages/video');
  }
}, {
  path: '/photo/:id',
  name: 'photo',
  component: function component() {
    return import('@/pages/photo');
  }
},
// 先付先抢已下架，为保险先注释，没问题后可删
// {
//   path: '/pre-list/',
//   name: 'preList',
//   component: () => import( '@/pages/pre-list' ),
// },
{
  path: '/old-member-verify/0/:companyId',
  name: 'oldMemberVerifyMobile',
  component: function component() {
    return import('@/pages/oldMember/verify-mobile');
  }
}, {
  path: '/old-member-verify/1/:companyId',
  name: 'oldMemberVerifyEmail',
  component: function component() {
    return import('@/pages/oldMember/verify-email');
  }
},
// 先付先抢已下架，为保险先注释，没问题后可删
// {
//   path: '/fgfbrule',
//   name: 'fbfgrule',
//   component: () => import( '@/pages/firstbuy-firstget-tutor' ),
// },
{
  path: '/miniprogram',
  name: 'miniprogram',
  component: function component() {
    return import('@/pages/miniprogram');
  }
}, {
  path: '/order-list',
  name: 'order-list',
  component: function component() {
    return import('@/pages/order-list');
  },
  meta: {
    keepAlive: true // 需要被缓存
  }
}, {
  path: '/privilege',
  name: 'privilege',
  component: function component() {
    return import('@/pages/privilege');
  }
}, {
  path: '/demacia-cup',
  name: 'DemaciaCup',
  component: function component() {
    return import('@/pages/demacia-cup');
  }
}, {
  path: '/order-detail',
  name: 'orderDetail',
  component: function component() {
    return import('@/pages/order-detail-route');
  }
}, {
  path: '/invoice',
  name: 'invoice',
  component: function component() {
    return import('@/pages/invoice');
  }
}, {
  path: '/artist',
  name: 'artist',
  component: function component() {
    return import('@/pages/artistByNew');
  }
}, {
  path: '/open/index',
  name: 'open',
  component: function component() {
    return import('@/pages/open/ActiveConfig');
  }
}, {
  path: '/open/middlePage',
  name: 'middlePage',
  component: function component() {
    return import('@/pages/open/gameMiddlePage');
  }
}, {
  path: '/today',
  name: 'today',
  component: function component() {
    return import('@/pages/today');
  }
}, {
  path: '/admission-record',
  name: 'admissionRecord',
  component: function component() {
    return import('@/pages/admission-record');
  }
}, {
  path: '/top/:id',
  name: 'top',
  component: function component() {
    return import('@/pages/top');
  }
}, {
  path: '/topList',
  name: 'top',
  component: function component() {
    return import('@/pages/top-list');
  }
}, {
  path: '/refund-ticket',
  name: 'refundTicket',
  component: function component() {
    return import('@/pages/refund-ticket');
  }
}, {
  path: '/give-manage',
  name: 'giveAway',
  component: function component() {
    return import('@/pages/giveAway/give-manage');
  }
}, {
  path: '/give-write',
  name: 'giveWrite',
  component: function component() {
    return import('@/pages/giveAway/give-write');
  }
}, {
  path: '/open/new-glory',
  name: 'newGlory',
  component: function component() {
    return import('@/pages/open/new-glory');
  }
}, {
  // 票转赠-接收管理
  path: '/receive-ticket',
  name: 'receive-ticket',
  component: function component() {
    return import('@/pages/receive-ticket/');
  }
}, {
  // 场馆推荐的商品列表
  path: '/venue/goods-list',
  name: 'venue-goods-list',
  component: function component() {
    return import('@/pages/goodsList/index');
  }
}, {
  // 票绑定身份
  path: '/ticket-bind',
  name: 'ticketBind',
  component: function component() {
    return import('@/pages/ticketBind/bind-info');
  }
}, {
  // 票绑定身份，新的，融合了绑定和查看票
  path: '/order-ticket-bind',
  name: 'order-ticket-bind',
  component: function component() {
    return import('@/pages/order-ticket-bind/index');
  }
}, {
  // 实名制观演票夹&h5验证证件号后六位
  path: '/order-ticket-verify',
  name: 'order-ticket-verify',
  component: function component() {
    return import('@/pages/order-ticket-bind/verifyById');
  }
}, {
  // 二维码检票
  path: '/qrcode-check',
  name: 'qrcode-check',
  component: function component() {
    return import('@/pages/qrCode/index');
  }
}, {
  // 票留言填写页面
  path: '/ticket-message',
  name: 'ticket-message',
  component: function component() {
    return import('@/pages/ticket-message/index');
  }
}, {
  // 隐私协议入口
  path: '/privacy',
  name: 'privacy',
  component: function component() {
    return import('@/pages/privacy/index');
  }
}, {
  // 演出日历页
  path: '/calendar',
  name: 'calendar',
  component: function component() {
    return import('@/pages/calendar');
  }
}, {
  // 新演出日历页
  path: '/new-calendar',
  name: 'new-calendar',
  component: function component() {
    return import('@/pages/calendar-main.vue');
  }
}, {
  // 卡司详情
  path: '/actor-detail',
  name: 'actor-detail',
  component: function component() {
    return import('@/pages/actor-detail/index');
  }
}, {
  // 分享落地页
  path: '/landing-page',
  name: 'landing-page',
  component: function component() {
    return import('@/pages/landing-page/index');
  }
}, {
  path: '/ticket-strategy',
  name: 'ticket-strategy',
  component: function component() {
    return import('@/pages/ticket-strategy/index');
  },
  meta: {
    keepAlive: true // 需要被缓存
  }
}, {
  // 新的下单页面
  path: '/buy',
  name: 'buy-confirm',
  component: function component() {
    return import('@/pages/buy/index');
  }
}, {
  path: '/brand/detail/:id',
  name: 'brandDetail',
  component: function component() {
    return import('@/pages/brand/detail');
  }
}, {
  path: '/brand/list/:id',
  name: 'brandList',
  component: function component() {
    return import('@/pages/brand/list');
  }
},
// 观演团
{
  path: '/performance-group-home',
  name: 'performanceGroupHome',
  component: function component() {
    return import('@/pages/performance-group/home');
  }
}, {
  path: '/performance-group-my-info',
  name: 'performanceGroupMyInfo',
  component: function component() {
    return import('@/pages/performance-group/my-info');
  }
}, {
  path: '/performance-group-activity-detail',
  name: 'performanceGroupActivityDetail',
  component: function component() {
    return import('@/pages/performance-group/activity-detail');
  }
}, {
  path: '/performance-group-answer-question',
  name: 'performanceGroupAnswerQuestion',
  component: function component() {
    return import('@/pages/performance-group/answer-question');
  }
}, {
  path: '/performance-group-registration-info',
  name: 'performanceGroupRegistrationInfo',
  component: function component() {
    return import('@/pages/performance-group/registration-info');
  }
}, {
  path: '/performance-group-submit-report',
  name: 'performanceGroupSubmitReport',
  component: function component() {
    return import('@/pages/performance-group/submit-report');
  }
}, {
  path: '/performance-group-preview-img',
  name: 'performanceGroupPreviewImg',
  component: function component() {
    return import('@/pages/performance-group/preview-img');
  }
}, {
  path: '/performance-group-admission',
  name: 'performanceGroupAdmission',
  component: function component() {
    return import('@/pages/performance-group/admission');
  }
}, {
  path: '/telephone-directory',
  name: 'telephone-directory',
  component: function component() {
    return import('@/pages/telephone-directory/index');
  }
},
// 申请退款页面
{
  path: '/request-refund-page',
  name: 'request-refund-page',
  component: function component() {
    return import('@/pages/request-refund-page');
  }
}, {
  path: '/show-info',
  name: 'show-info',
  component: function component() {
    return import('@/pages/show-info/index');
  }
}, {
  path: '/faceConfirm',
  name: 'face-confirm',
  component: function component() {
    return import('@/pages/face-confirm');
  }
}, {
  path: '/order-progress',
  name: 'order-progress',
  component: function component() {
    return import('@/pages/order-progress');
  }
}, {
  path: '/license-info/:performanceId',
  name: 'license-info',
  component: function component() {
    return import('@/pages/licenseInfo/licenseInfoPage');
  }
}, {
  path: '/error-page',
  name: 'error-page',
  component: function component() {
    return import('@/pages/error-page/index');
  }
},
// 实名须知
{
  path: '/real-name-notice',
  name: 'real-name-notice',
  component: function component() {
    return import('@/pages/real-name-notice');
  }
}, {
  path: '/pay-success',
  name: 'pay-success',
  component: function component() {
    return import('@/pages/pay-success/index');
  }
}];
routes.push.apply(routes, _toConsumableArray(FansRouter).concat(_toConsumableArray(TengjingRouter), _toConsumableArray(MaidanbaRouter), _toConsumableArray(LiveRouter), _toConsumableArray(CommentsRouter), _toConsumableArray(CmbAppRouter)));
/*
  注： 所有页面路由均以【 异步形式 】加载 以保证首屏加载 速度;
  eg.: component: () => import('@/pages/venue-list')
*/
var router = new Router({
  // mode: 'history',
  routes: routes
});
router.beforeEach(function (to, _ref, next) {
  var fromPath = _ref.path,
    fromQuery = _ref.query,
    fromName = _ref.name;
  window.previousUrlObject = {
    // 记录上一跳页面
    path: fromPath,
    query: fromQuery,
    name: fromName
  };
  var path = to.path,
    query = to.query;

  // if (to) {
  //   owlResetPv({
  //     pageUrl: to.name
  //   })
  // }

  if (Drip.UA.isNative && query._blank === true && path !== fromPath) {
    // 处理 native 环境下 scheme 跳转问题
    var _window$location = window.location,
      href = _window$location.href,
      hash = _window$location.hash;
    path = path.startsWith('#') ? path : '#' + path;
    var url = href.replace(hash, path);
    Drip.redirect(url);
  } else {
    next();
  }
});
export default router;